import { BackendModule, Services, ReadCallback, CallbackError } from 'i18next'

interface LocalBackendOptions {
  resources: {
    [language: string]: {
      [namespace: string]: object
    }
  }
}

const DEFAULT_OPTIONS: LocalBackendOptions = { resources: {} }

class LocalBackend implements BackendModule<LocalBackendOptions> {
  services!: Services
  options!: LocalBackendOptions
  type: 'backend' = 'backend'

  constructor(services: Services, options: LocalBackendOptions = DEFAULT_OPTIONS, allOptions = {}) {
    this.init(services, options, allOptions)
  }

  init(services: Services, options: LocalBackendOptions = DEFAULT_OPTIONS, allOptions = {}) {
    this.services = services
    this.options = { ...options, resources: { ...options.resources } }
  }

  read(language: string, namespace: string, callback: ReadCallback) {
    try {
      const resources = this.options.resources
      if (resources?.[language]?.[namespace]) {
        return callback(null, resources[language][namespace])
      }
      callback(new Error(`Local resource for ${language}/${namespace} not found.`), false)
    } catch (err) {
      callback(err as CallbackError, false)
    }
  }

  create(_languages: string[], _namespace: string, _key: string, _fallbackValue: string) {
    // Not implemented: this is a read-only backend
  }
}

export default LocalBackend
